export enum BoardCodeToDisplayNameEnum {
  BB = 'Bed And Breakfast',
  HB = 'Half Board',
  RO = 'Room Only',
  FB = 'Full Board',
  SC = 'Self Catering',
  MB = 'Half Board With Beverages Includes',
  AI = 'All Inclusive',
}
